import { motion } from "framer-motion";
import Footer from "../Footer/Footer";
import "./CustomCursor.scss";

const CustomCursor = ({ cursorVariant, variants }) => {
  if (cursorVariant !== "diff" && cursorVariant !== "differ")
    return (
      <motion.div
        data-scroll-section
        className="cursor"
        variants={variants}
        animate={cursorVariant}
      ></motion.div>
    );
  else if (cursorVariant === "diff") {
    return (
      <motion.div
        data-scroll-section
        className="cursor"
        variants={variants}
        animate={cursorVariant}
      >
        <Footer
          text={"visit - visit - visit - visit - visit - "}
          type="visit"
        />
        ;
      </motion.div>
    );
  } else if (cursorVariant === "differ") {
    return (
      <motion.div
        data-scroll-section
        className="cursor"
        variants={variants}
        animate={cursorVariant}
      >
        <Footer text={"Get in touch   -   Get in touch   -   "} type="differ" />
        ;
      </motion.div>
    );
  } else if (cursorVariant === "info") {
    <motion.div
      data-scroll-section
      className="cursor"
      variants={variants}
      animate={cursorVariant}
    >
      <Footer text={"Get in touch   -   Get in touch   -   "} type="info" />;
    </motion.div>;
  }
};

export default CustomCursor;
